import React from "react"

import ConditionTypeSelector from "../../../proto/render/condition/condition-type-selector"
import SelectMultiGenericNew from "../../../../gd-ui/select-multi-generic-new/select-multi-generic-new"
import FieldStatus_MultiselectValueNotEmpty from "../../../generic/status/components/multiselect/value-not-empty"
import FieldStatus_MultiselectPopoverOption from "../../../generic/status/components/multiselect/option"
import Filter from "../../../../manager/filters/manager/filter"
import {ConditionType} from "../../../../model2/conditions/condition-types"
import {FieldConditionFormProps, FieldConditionRenderMode} from "../../../render/condition/@types"
import FieldStatus from "../status"

// const debug = "FieldTaskStatus_ConditionForm"
const debug = false

export default function FieldStatus_ConditionForm(props:FieldConditionFormProps) {

    const onChangeType = (conditionType: ConditionType) => {
        props.condition.type = conditionType
        props.onChangeCallback(props.condition.type, props.condition.value)
    }

    const onChangeValue = (value: any) => {
        props.condition.value = value
        props.onChangeCallback(props.condition.type, props.condition.value)
    }

    const getOptions = async (): Promise<Option[]> => {
        switch (props.renderMode) {
            case FieldConditionRenderMode.FILTER_ITEMS_COLLECTION:
            case FieldConditionRenderMode.FILTER_COLLECTION:
                const filter = props.condition as Filter
                const field = filter.field as FieldStatus
                return await field.filterGetOptions(filter)

            case FieldConditionRenderMode.CONDITION:
            default:
                // doesn't apply
                return []
        }
    }

    return (
        <>
            <ConditionTypeSelector field    = {props.field}
                                   value    = {props.condition.type}
                                   onChange = {onChangeType}/>

            <SelectMultiGenericNew className                        = "selector w-250 m-l-10"
                                   options                          = {gd.session.statuses.toOptions()}
                                   getPopoverOptions                = {getOptions}
                                   values                           = {props.condition.value}
                                   popoverScrollContainerClasses    = "max-h-200 max-w-300"
                                   valueComponent                   = {FieldStatus_MultiselectValueNotEmpty}
                                   popoverOptionComponent           = {FieldStatus_MultiselectPopoverOption}
                                   isSearchable                     = {true}
                                   onChange                         = {onChangeValue}/>
        </>
    )
}
